export default {
  roles: {
    superAdmin: 'SUPER_ADMIN',
    admin: 'ADMIN',
    user: 'USER',
  },
  etat: {
    inactif: 'INACTIF',
    actif: 'ACTIF',
  },
};
